export const SOCIAL_MEDIA: {
  YOUTUBE_CHANNEL?: string;
  VK_GROUP?: string;
  OK_GROUP?: string;
  TWITTER?: string;
} = {
  YOUTUBE_CHANNEL: 'https://www.youtube.com/channel/UCSBSIORfT1aKyOu--_DuY3w',
  OK_GROUP: 'https://ok.ru/group/58024651784263',
  TWITTER: 'https://twitter.com/youhelp_ru',
  VK_GROUP: 'https://vk.com/youhelpru',
};
export type SocialMediaConfig = Partial<typeof SOCIAL_MEDIA>;
